import R from 'ramda';
import { createAction } from 'redux-actions';

import { getFeatureFlags } from 'ha/modules/FeatureFlags';

import { mapHasBounds, isMapAutoSearchEnabled } from '../selectors';
import { Actions } from '../constants';

export const highlightRoom = createAction(Actions.HIGHLIGHT_ROOM);
export const unhighlightRoom = createAction(Actions.UNHIGHLIGHT_ROOM);

export const highlightInfoWindow = createAction(Actions.HIGHLIGHT_INFO_WINDOW);
export const unhighlightInfoWindow = createAction(
  Actions.UNHIGHLIGHT_INFO_WINDOW,
);

export const clearPreviewNumberOfListings = createAction(
  Actions.LOAD_PREVIEW_NUMBER_OF_LISTINGS_CLEAR,
);

export const showInfoWindow = createAction(Actions.SHOW_INFO_WINDOW);
export const hideInfoWindow = createAction(Actions.HIDE_INFO_WINDOW);

export const updateBounds = createAction(Actions.UPDATE_BOUNDS);
export const updateMap = createAction(Actions.UPDATE_MAP);
const updateMapNext = createAction(Actions.UPDATE_MAP, null, payload => ({
  queryParams: {
    lat: payload?.center.lat,
    lng: payload?.center.lng,
    zoom: payload?.zoom,
  },
  mergeQueryParams: true,
  replaceQueryParams: true,
}));

export const resetMap = createAction(Actions.RESET_MAP, null, () => ({
  queryParams: {
    lat: null,
    lng: null,
    zoom: null,
  },
  mergeQueryParams: true,
  replaceQueryParams: true,
}));

export const updateMapCenter = createAction(Actions.UPDATE_MAP_CENTER);
export const incrementMapZoomLevel = createAction(
  Actions.INCREMENT_MAP_ZOOM_LEVEL,
);

export const onPinClick = params => dispatch => {
  dispatch(updateMapCenter(params));
  dispatch(incrementMapZoomLevel());
};

export const disableMap = createAction(Actions.DISABLE_MAP);
export const toggleMapAutoSearch = createAction(Actions.TOGGLE_MAP_AUTO_SEARCH);
export const updateSearchParams = createAction(Actions.UPDATE_SEARCH_PARAMS);
export const setPreviousParams = createAction(Actions.SET_PREVIOUS_PARAMS);
export const toggleFilterPopover = createAction(Actions.TOGGLE_FILTER_POPOVER);

export const toggleMobileMap = createAction(Actions.TOGGLE_MOBILE_MAP);
export const toggleMobileDatePicker = createAction(
  Actions.TOGGLE_MOBILE_DATE_PICKER,
);

export const trackFilterApplied = createAction(
  Actions.FILTER_APPLIED,
  () => ({}),
  payload => ({
    analytics: {
      type: 'Search filter applied',
      payload,
    },
  }),
);

export const changePage = createAction(
  Actions.CHANGE_PAGE,
  R.identity,
  payload => ({
    queryParams: {
      page: payload && payload.num && payload.num > 1 ? payload.num : null,
    },
    mergeQueryParams: true,
  }),
);

export const replacePage = createAction(
  Actions.REPLACE_PAGE,
  R.identity,
  ({ pathname }) => ({
    pathname,
    replaceQueryParams: true,
    mergeQueryParams: true,
    queryParams: {},
  }),
);

export const onMapUpdate = () => dispatch => {
  dispatch(changePage(null));
};

export const onMapChanged = params => (dispatch, getState) => {
  dispatch(updateMap(params));

  const state = getState();
  const { appendMapParamsToURL } = getFeatureFlags(state);

  const action =
    appendMapParamsToURL === 'on' ? updateMapNext(params) : updateMap(params);

  dispatch(action);

  if (mapHasBounds(state) && isMapAutoSearchEnabled(state)) {
    dispatch(onMapUpdate());
  }
};
